<div class="container">
    <app-toolbar (toggle)="toggleSidenav()"></app-toolbar>
    <app-sidenav></app-sidenav>
    <app-footer></app-footer>
</div>
